import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'delete-modal',
    template: require('./delete.modal.component.html')
})
export class DeleteModalComponent {
    @Input() typeName: string;
    @Input() message: string;
    @Input() elementId: string;
    @Input() editPermissionName: string;
    @Input() verb = 'delete';
    @Output() deleteConfirmed = new EventEmitter<any>();

    get elementIdOrDefault() { return this.elementId ? this.elementId : 'delete-modal' }
    
    entityName: string;
    deleteDto: any;
    
    confirm() {
        this.deleteConfirmed.emit(this.deleteDto);
    }

    typeNameCapitalised() {
        if (!this.typeName) return null;
        return this.typeName.replace(/\b(\w)/g, s => s.toUpperCase());
    }

    verbCapitalised() {
        if (!this.verb) return null;
        return this.verb.replace(/\b(\w)/g, s => s.toUpperCase());
    }

    showAndPopulate(entity: any, entityName: string) {
        $(`#${this.elementIdOrDefault}`).modal();
        this.deleteDto = entity;
        this.entityName = entityName;
    }

    clearAndHide() {
        $(`#${this.elementIdOrDefault}`).modal('hide');
        this.deleteDto = null;
        this.entityName = null;
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/components/common/deletemodal/delete.modal.component.ts